<template>
  <div class="header-view">
    <!-- 展开收起 -->
    <menu-unfold-outlined
      v-if="collapsed"
      class="layout-trigger"
      @click="touchCollapsed"
    />
    <menu-fold-outlined
      v-else
      class="layout-trigger"
      @click="touchCollapsed"
    />
    <!-- 弹簧 -->
    <div style="flex: 1;"></div>
    <!-- 下拉菜单 -->
    <a-dropdown :trigger="['click']">
      <div class="info-view">
        <!-- 头像 -->
        <img class="info-avatar" :src="require('@/assets/img/avatar.svg')">
        <!-- 信息 -->
        <div class="corporate-info">
          <div class="corporate-name">{{ userinfo.username || userinfo.phone }}</div>
        </div>
        <!-- 箭头 -->
        <caret-down-outlined class="info-arrow"  />
      </div>
      <template #overlay>
        <a-menu>
          <!-- 退出登录 -->
          <a-menu-item @click="touchModify">
            <form-outlined /> 修改密码
          </a-menu-item>
          <!-- 退出登录 -->
          <a-menu-item @click="touchLogout">
            <export-outlined class="operation-icon" /> 退出登录
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
  </div>
  <!-- 修改密码 -->
  <ModifyPwdModal ref="RefModifyPwdModal"></ModifyPwdModal>
</template>

<script setup>
// 导入
import { onBeforeMount, ref, reactive } from 'vue'
import Pub from '@/utils/public'
import ModifyPwdModal from './ModifyPwdModal.vue'

// 切换
let collapsed = ref(false)
// 修改密码
let RefModifyPwdModal = ref(null)
// emit
const emit = defineEmits(['collapsed'])
// 用户信息
const userinfo = JSON.parse(Pub.USERINFO() || '{}')

// 切换
function touchCollapsed () {
  collapsed.value = !collapsed.value
  emit('collapsed', collapsed.value)
}

// 退出
function touchLogout () {
  Pub.LOGOUT()
}

// 修改密码
function touchModify () {
  RefModifyPwdModal.value.showModal()
}
</script>

<style lang="less" scoped>
.header-view {
  display: flex;
  background-color: #001529;
}
.info-view {
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-right: 48px;
}
.info-view .info-avatar {
  display: inline-block;
  width: 36px;
  height: 36px;
  object-fit: cover;
  border-radius: 100%;
}
.info-view .info-arrow {
  margin-left: 8px;
  color: #fff;
}
.corporate-info {
  margin-left: 10px;
}
.corporate-name {
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
  color: #fff;
}
.operation-logout {
  color: #E34D59;
}
.operation-icon {
  color: #E62412;
  font-size: 14px !important;
}
</style>